/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {fixBadInstrumentLinkTokens} from '../api'

export const useMutationFixBadInstrumentLinkTokens = createReactQueryMutationHook('fixBadInstrumentLinkTokens', fixBadInstrumentLinkTokens)
